<template>
  <div>
    <span class="condition-icons-wrapper" v-if="canAccess(access.FULL, accessLevel)">
      <ConnectionStatus :deviceId="deviceId" />
      <BatteryStatus :deviceId="deviceId" />
      <EolAlert :deviceId="deviceId" />
      <DeviceAlerts :deviceId="deviceId" />
      <CommunicationStatus :deviceId="deviceId" />
      <OfflineStudiesStatus :deviceId="deviceId" />
      <LiveStudiesStatus :deviceId="deviceId" />
    </span>
    <span v-else class="not-available-text">
      {{ $t('manageDevices.notAvailable') }}
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import { useAccess, Access } from '@/services/device-access'

import BatteryStatus from '@/components/icons/BatteryStatus.vue'
import ConnectionStatus from '@/components/devicePopover/content/title/connectionStatus.vue'
import CommunicationStatus from '@/components/icons/CommunicationStatus.vue'
import OfflineStudiesStatus from '@/components/icons/OfflineStudiesStatus.vue'
import LiveStudiesStatus from '@/components/icons/LiveStudiesStatus.vue'
import EolAlert from '@/components/devicePopover/content/title/eolAlert.vue'
import DeviceAlerts from '@/components/devicePopover/content/title/deviceAlerts.vue'

export default defineComponent({
  name: 'ManageDevicesTableCondition',
  props: {
    deviceId: {
      type: String,
      default: ''
    },
    accessLevel: {
      type: Number as PropType<Access>,
      default: 0
    }
  },
  components: {
    BatteryStatus,
    ConnectionStatus,
    CommunicationStatus,
    EolAlert,
    DeviceAlerts,
    OfflineStudiesStatus,
    LiveStudiesStatus
  },
  setup() {
    const { canAccess, access } = useAccess()
    return { canAccess, access }
  }
})
</script>
<style lang="scss" scoped>
.condition-icons-wrapper {
  display: flex;
  margin: 0 -4px;
}
:deep(.popover-status-icon) {
  min-width: 36px;
  padding: 0 4px;
  font-size: 1rem;
  .v-icon {
    --v-icon-size-multiplier: 1;
  }
}
</style>
